// Google Analytics 4 (GA4) Utility Functions

/**
 * Track GA4 events safely
 * @param {string} eventName - The event name
 * @param {Object} parameters - Event parameters
 */
export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
};

/**
 * Track appointment form submission
 */
export const trackAppointmentFormSubmitted = () => {
  trackEvent('appointment_form_submitted', {
    event_category: 'Appointments',
    event_label: 'Appointment Booking Form',
  });
};

/**
 * Track WhatsApp button click
 */
export const trackWhatsAppClicked = () => {
  trackEvent('whatsapp_clicked', {
    event_category: 'Contact',
    event_label: 'WhatsApp CTA Button',
  });
};

/**
 * Track call now button click
 */
export const trackCallNowClicked = () => {
  trackEvent('call_now_clicked', {
    event_category: 'Contact',
    event_label: 'Call Now Button',
  });
};

/**
 * Track book appointment button click
 * @param {string} location - Where the button is located (e.g., 'Banner', 'Navbar')
 */
export const trackBookAppointmentClicked = (location = 'Unknown') => {
  trackEvent('book_appointment_clicked', {
    event_category: 'Appointments',
    event_label: `Book Appointment ${location} Button`,
  });
};

/**
 * Track contact us button click
 * @param {string} location - Where the button is located (e.g., 'About Page', 'Footer')
 */
export const trackContactUsClicked = (location = 'Unknown') => {
  trackEvent('contact_us_clicked', {
    event_category: 'Contact',
    event_label: `Contact Us ${location} Button`,
  });
};

/**
 * Track page view
 * @param {string} pageTitle - The page title
 * @param {string} pagePath - The page path
 */
export const trackPageView = (pageTitle, pagePath) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('config', 'G-K5755GLLJY', {
      page_title: pageTitle,
      page_path: pagePath,
    });
  }
}; 